import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';
import * as cmAction from 'actions/commons';
import * as usageAction from 'actions/usage';
import * as etcAction from 'actions/etc';

import { Modal } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Form, Checkbox } from 'semantic-ui-react';
import { Pagination, SearchInputBox, TableForm, LoadingBar, Division, SikdaeGroup } from 'components/Commons';

import BarcodeMemberDetailModal from './BarcodeMemberDetailModal';

const Wrapper = styled.main`
  .inverted-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 33px;
    padding: 0px;
    line-height: 26px;
  }
`;
const TableWrapper = styled.div`
  .ui.table {
    margin-bottom: 16px;
    & > tbody > tr > td.left.aligned:last-child {
      padding: 0px 11px;
      button {
        line-height: 22px;
      }
    }
  }
`;

const defaultColumns = [
  { header: 'ID', name: 'signId', textAlign: 'left', width: 100 },
  { header: '이름', name: 'name', textAlign: 'left' },
  { header: '사번', name: 'employeeId', textAlign: 'left' },
  { header: '식대그룹', name: 'groupName', textAlign: 'left' },
  { header: '사원증 결제 정보', name: 'barCode', textAlign: 'left' },
  { header: '', name: 'test', textAlign: 'left', width: 100 }
];

const generateColumns = (values) => {
  const columns = cm
    .tableHeaderList(defaultColumns, 4, false, 'notMaxWidth')
    .map((item) => ({ ...item, textAlign: 'left' }));
  const thead = columns.map((item) => ({ data: item.header, ...item }));
  const tbody = values.map((value) => {
    const division = cm.trTdDivision(value.orgCode);
    const row = columns.map((item) => {
      let data = value[item.name] || '-';
      if (item && item.header.includes('부서')) {
        const idx = Number(item.header.replace('부서', '')) - 1;
        data =
          (
            <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {division[idx] || '-'}
            </div>
          ) || '-';
      }
      return { data, ...item, width: 220 };
    });
    return { row };
  });
  return { thead, tbody: values.length ? tbody : undefined };
};

const BarcodeMembers = ({
  division,
  orgCode,
  keyword,
  groupIdx,
  sikdaeGroup,
  commonsAPI,
  usageAPI,
  etcAPI,
  barcodeMembers,
  authStaffDet
}) => {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [user, setUser] = useState(null);
  const [hasBarCode, setHasBarCode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultOrgCode, setDefaultOrgCode] = useState(undefined);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const info = storage.get('info');
      const isDivision = !!authStaffDet && !!authStaffDet.data && authStaffDet.data.presetIdx === 5;
      const organization = isDivision ? ((info || {}).auth || {}).organization : undefined;
      // 부서 제한 권한인데 부서 정보를 얻지 못하면 전체 범위로 조회되지 않도록 중단한다
      if (isDivision && !organization) return;
      setDefaultOrgCode(organization ? [organization] : undefined);

      const params = {
        groupIdx,
        orgCode: orgCode || organization,
        keyword,
        hasBarCode: hasBarCode ? !hasBarCode : undefined
      };
      await usageAPI.getBarcodeMembers(params);
      setPage(1);
    } catch (e) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const company = storage.get('company');
    commonsAPI.sikdaeGroupList();
    etcAPI.authStaffDet({ id: ((company || {}).user || {}).id });
  }, []);

  useEffect(() => {
    if (authStaffDet) {
      handleSubmit();
    }
  }, [authStaffDet]);

  const handleOnOffModal = () => setOpen(!open);
  const handlePageChange = (value) => setPage(value);

  const updateBarcodeBulk = async () => {
    const info = storage.get('info');
    const isDivision = !!authStaffDet && !!authStaffDet.data && authStaffDet.data.presetIdx === 5;

    const organization = ((info || {}).auth || {}).organization;
    // 부서 제한 권한인데 부서 정보를 얻지 못하면 전체 범위로 생성되지 않도록 중단한다
    if (isDivision && !organization) return;

    const result = await usageAPI.createBarcodeBulk({ orgCode: isDivision ? organization : undefined });
    const bulkStatus = { ...(result.value || {}) }.data || {};

    Modal.confirm({
      title: '사원증 결제정보 일괄 생성',
      content: (
        <div style={{ paddingTop: '16px', textAlign: 'center', color: '#353C49' }}>
          <div>
            총 ({bulkStatus.totalCount || 0}) : 성공({bulkStatus.successCount || 0}) / 실패({bulkStatus.failCount || 0})
          </div>
          <div>사원증 결제정보 수정이 완료되었습니다.</div>
          <div>실패한 경우 사번을 확인해주세요.</div>
        </div>
      ),
      icon: null,
      okText: '확인',
      cancelButtonProps: { style: { display: 'none' } },
      onOk: () => handleSubmit()
    });
  };

  const createBarcode = async (barCodeUserInfo) => {
    try {
      await usageAPI.createBarcode({ barCodeUserInfo });
      await handleSubmit();
      await toastr('top-right', 'success', '사원증 결제정보 수정이 완료되었습니다.');
    } catch (error) {
      if (error && error.response && error.response.data) {
        const { message } = error.response.data;
        toastr('top-right', 'error', message);
      }
    }
  };

  const handleCreateBarcodeBulk = (isBulk, params) => {
    Modal.confirm({
      title: isBulk ? '사원증 결제정보 일괄 생성' : '사원증 결제정보 생성',
      content: (
        <div style={{ textAlign: 'center', color: '#353C49' }}>
          <div style={{ paddingTop: '16px' }}>
            <span style={{ fontWeight: 700 }}>사원증 결제 정보</span> : <span>C01000 + 사번</span>
          </div>
          <div style={{ paddingTop: '16px' }}>앞 6자리가 C01000이 아닌 경우</div>
          <div>
            <span>결제정보 일괄 생성 후 </span>
            <span style={{ fontWeight: 700 }}>[사원증 결제정보 수정]을 통해</span>
          </div>
          <div>사원증 결제 정보 수정을 진행해주세요.</div>
        </div>
      ),
      icon: null,
      okText: isBulk ? '일괄 생성' : '생성',
      cancelText: '취소',
      okButtonProps: { style: { borderRadius: '4px', background: '#3EA856', color: '#ffffff' } },
      cancelButtonProps: { style: { borderRadius: '4px', background: '#FE5657', color: '#ffffff' } },
      onOk: async () => {
        if (isBulk) {
          updateBarcodeBulk();
        } else {
          createBarcode(params.userInfo);
        }
      }
    });
  };

  const tableData = useMemo(() => {
    const { group } = sikdaeGroup || {};
    const array = barcodeMembers ? barcodeMembers.users.slice((page - 1) * 15, page * 15) : [];
    const users = array.map((item) => {
      const groupInfo = group && group.find(({ idx }) => idx === item.userInfo.groupIdx);
      return {
        ...item.userInfo,
        ...item.barCodeInfo,
        groupName: groupInfo ? groupInfo.name : '-',
        test: (
          <Button
            color="black"
            content={item.barCodeInfo && item.barCodeInfo.barCode ? '사원증 결제정보 수정' : '사원증 결제정보 생성'}
            inverted
            style={{ width: '160px', height: '32px' }}
            onClick={async () => {
              const hasBarcode = item.barCodeInfo && item.barCodeInfo.barCode;
              setUser(item);

              if (hasBarcode) {
                handleOnOffModal(item);
              } else {
                handleCreateBarcodeBulk(hasBarcode, item);
              }
            }}
          />
        )
      };
    });
    const { thead, tbody } = generateColumns(users);
    return { header: { main: thead }, body: { main: tbody, message: '내역이 존재하지 않습니다' } };
  }, [barcodeMembers, sikdaeGroup, page]);

  return (
    <Wrapper className="usgl">
      {isLoading ? <LoadingBar /> : null}
      <div className="top-btn button" style={{ top: '86px' }}>
        <Button inverted color="green" className="inverted-button" onClick={() => handleCreateBarcodeBulk(true)}>
          사원증 결제정보 일괄 생성
        </Button>
      </div>

      <Form onSubmit={handleSubmit} style={{ marginLeft: '-7px' }}>
        <Form.Group className="form-input">
          <SearchInputBox placeHolder="ID, 이름, 사번" handleSubmit={handleSubmit} />
          <SikdaeGroup style={{ height: '32px' }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '0px 7px' }}>
            <span style={{ paddingTop: '4px', fontWeight: 700 }}>사원증 결제 정보가 없는 사용자보기</span>
            <Checkbox toggle onChange={(_, { checked }) => setHasBarCode(checked)} />
          </div>
          <Button
            color="black"
            content="조회"
            inverted
            style={{ width: '100px', height: '32px', margin: '0px 7px', marginLeft: 'auto' }}
          />
        </Form.Group>
        <Form.Group>
          <Division id="orgCode" division={division} defaultValue={defaultOrgCode} style={{ margin: '0px 7px' }} />
        </Form.Group>
      </Form>

      <TableWrapper className="table-box table-paging">
        <div style={{ textAlign: 'left' }}>검색결과 : {barcodeMembers ? barcodeMembers.totalCount : 0}건</div>
        <TableForm selectable="true" tabledata={tableData} />
        <Pagination
          page={page}
          pageRow={15}
          pageBlock={10}
          totalCount={barcodeMembers ? barcodeMembers.totalCount : 0}
          pageClick={handlePageChange}
        />
      </TableWrapper>

      <BarcodeMemberDetailModal open={open} user={user} onClose={handleOnOffModal} onSuccess={handleSubmit} />
    </Wrapper>
  );
};

export default connect(
  (state) => ({
    division: state.commons.division, // 부서 리스트
    orgCode: (state.commons.depth || {}).value, // Division 부서 value
    keyword: (state.commons.text || {}).value,
    groupIdx: (state.commons.group || {}).value,
    sikdaeGroup: (state.commons.sikdaeGroup || {}).data,
    barcodeMembers: (state.usage.barcodeMembers || {}).data,
    authStaffDet: state.etc.authStaffDet
  }),
  (dispatch) => ({
    commonsAPI: bindActionCreators({ sikdaeGroupList: cmAction.SikdaeGroupList }, dispatch),
    usageAPI: bindActionCreators(
      {
        getBarcodeMembers: usageAction.getBarcodeMembers,
        createBarcodeBulk: usageAction.createBarcodeBulk,
        createBarcode: usageAction.createBarcode
      },
      dispatch
    ),
    etcAPI: bindActionCreators({ authStaffDet: etcAction.AuthStaffDet }, dispatch)
  })
)(BarcodeMembers);
